<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <Notifications />
        <InternalOrdersCard
          class="card mb-3"
          title="Interni nalogi"
          subTitle="Accepted, zame"
          :ownerID="worker.id.value"
          statuses="Accepted"
          v-if="worker.id.value"
        />
      </div>
      <div class="col-md-4">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title">Bližnjice</h5>
            <ul>
              <li>
                <button
                  class="btn btn-link"
                  type="button"
                  @click="$router.push({ name: 'InternalOrder', params: { workOrderId: 'new' } })"
                >
                  Nov interni nalog
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <WorkersCard class="card mb-3" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <ProductionOrdersCard class="card mb-3" />
      </div>
      <div class="col-md-6">
        <WorkersWithWorkOrdersCard class="card mb-3" />

        <DevicesCard class="card mb-3" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject, onUnmounted } from "vue"
import { useWorker } from "../composition-api/useWorker"

import FacilitiesCard from "../components/FacilitiesCard.vue"
import InternalOrdersCard from "../components/InternalOrdersCard.vue"
import WarehouseTransfersCard from "../components/WarehouseTransfersCard.vue"
import WorkersCard from "../components/WorkersCard.vue"
import Notifications from "../components/Notifications.vue"
import WorkersWithWorkOrdersCard from "../components/WorkersWithWorkOrdersCard.vue"
import ProductionOrdersCard from "../components/ProductionOrdersCard.vue"

defineOptions({ name: "HomeLeaderProduction" })

const { worker } = useWorker()
const workersCardEl = ref(null)
</script>
